export class Auth{
  constructor(
    public username:string,
    public password: string
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/auth.model.ts